import { useState } from "react";
import type { InputProps } from "../../../../types";
import { classNameParser } from "../../../../helpers";
import "../../../../styles/input.css";
import "./style.css";

type CheckboxInputProps = InputProps<
  boolean,
  {
    large?: boolean;
  }
>;

export const CheckboxInput = (props: CheckboxInputProps) => {
  const [value, setValue] = useState(props.value || false);

  const handleChange = () => {
    const checked = !value;
    setValue(checked);
    props.onChange && props.onChange(checked);
  };

  return (
    <label
      htmlFor={props.id}
      key={props.key}
      className={classNameParser("input--checkbox-box" + (props.disabled === true ? " disable" : ""), props.className)}
      style={props.style}
    >
      {props.children}
      <input type="checkbox" id={props.id} disabled={props.disabled} checked={value} onChange={handleChange} />
      <span
        className={`input--checkbox-box-checkmark${props.large === true ? "-large" : ""} ${props.error ? "error" : ""}`}
      ></span>
      {props.error && <p className="global--input-error">{props.error}</p>}
    </label>
  );
};
